import React, { useState } from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../../utils/resolveProps'

const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    },
    'inverse'
  ],
  modifiers: [],
  states: []
}

const Collapse = (props) => {
  const { inverse, children, title, className, ...rest } = props
  const [isOpen, setIsOpen] = useState(false)
  const _collapse = React.useRef(null)

  const togglePanel = (e) => {
    const currentState = !isOpen
    setIsOpen(currentState)
  }
  const handleKeyPress = (e) => {
    if (e.charCode === 32 || e.charCode === 13) {
      togglePanel(e)
    }
  }
  return (
    <div
      {...rest}
      ref={_collapse}
      onKeyPress={ (e) => handleKeyPress(e)}
      tabIndex={0}
      className={`${resolveProps(props, config, 'Collapse')} ${
        isOpen ? ' mdn-Collapse-active ' : ''
      } ${className || ''}`}
    >
      <div className="mdn-Collapse-box" onClick={togglePanel}>
        <a className="mdn-Collapse-toggle mdn-Text mdn-Text--body">
          {title}
          <span className="mdn-Collapse-icon mdn-Icon-baixo mdn-Icon--md"></span>
        </a>
      </div>
      <div className="mdn-Collapse-content">
        <div className="mdn-Container mdn-u-color--secondary">{children}</div>
      </div>
    </div>
  )
}

export default Collapse
